import Banner from "../Components/Shared/Layout/Banner";
import IntroBlock from "../Components/Shared/Layout/IntroBlock";
import withLanguage from "../HOC/withLanguage";
import React, { useState } from "react";
import VideoInfoGrid from "../Components/Shared/Layout/VideoInfoGrid";

const CareerAdvice = ({ language }) => {
    const [currentVideoUrl, setCurrentVideoUrl] = useState(null);

    const careerAdviceData = [
        {
            title: "Sugjerime për hartimin e CV-së dhe letrës së motivimit.",
            buttonText: "Video me udhezimet",
            videoUrl: "http://www.youtube.com/watch?v=FcNQDvTuN10"
        },
        {
            title: "Udhëzime për intervistat e punës dhe mënyrën e prezantimit.",
            buttonText: "Video per hartimin e CV dhe letres se motivimit",
            videoUrl: "http://www.youtube.com/watch?v=FcNQDvTuN10"
        },
        {
            title: "Informacione mbi aftësitë më të kërkuara në tregun e punës.",
            buttonText: "Video me udhezimet ose pershkrim I detajuar",
            videoUrl: "http://www.youtube.com/watch?v=MYfWDygRLhQ"
        },
        {
            title: "Këshilla për zhvillimin profesional dhe ndërtimin e karrierës.",
            buttonText: "Video me udhezimet ose pershkrim I detajuar",
            videoUrl: "http://www.youtube.com/watch?v=203PoWnB5Kk"
        }
    ];

    const handleOpenModal = (url) => {
        setCurrentVideoUrl(url);
    };

    const handleCloseModal = () => {
        setCurrentVideoUrl(null);
    };

    return (
        <>
            <Banner img='/CareerAdvice/banner.jpg' title={language.banner} />
            <IntroBlock>{language.intro}</IntroBlock>

            <div className="m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">
                <VideoInfoGrid apiPath="keshilla_karriere"/>
            </div>

        </>
    );
};

export default withLanguage(CareerAdvice, "CareerAdvice");